// A config object mapping screen widths to
// how many channel slates should display in each row
export const channelGridSizeCountMap = [
  {
    max: 550,
    count: 2
  },
  {
    min: 551,
    max: 700,
    count: 3
  },
  {
    min: 701,
    max: 900,
    count: 4
  },
  {
    min: 901,
    max: 1250,
    count: 5
  },
  {
    min: 1251,
    max: 1750,
    count: 6
  },
  {
    min: 1751,
    max: 2150,
    count: 7
  },
  {
    min: 2151,
    count: 8
  }
];